import { DeleteFolderModalView } from "src/core/components/folder/footer/DeleteFolderModalView";
import { FolderFileDeletionFragment } from "src/core/gql/graphql";
import { useDeleteFolderController } from "src/core/hooks/folder/footer/useDeleteFolderController";

type DeleteFolderModalProps = {
  open: boolean;
  onClose: () => void;
  folderFile: FolderFileDeletionFragment;
};
export const DeleteFolderModal: React.FC<DeleteFolderModalProps> = ({
  open,
  onClose,
  folderFile,
}) => {
  const { loading, confirm } = useDeleteFolderController(folderFile);

  return (
    <DeleteFolderModalView open={open} loading={loading} onConfirm={confirm} onClose={onClose} />
  );
};
